import React, { Component } from 'react'

export default class FileNameDisplay extends Component {

  handleChange(e){
    this.props.changeFilename(e.target.value)
  }

  render() {
    return (
      <input className="name-input" placeholder="Dateiname" type="text" value={this.props.filename} onChange={this.handleChange.bind(this)}/>
    )
  }
}
